<template>
  <div class="homePage04Box" :style="bg">
    <!-- 头部导航 -->
    <div class="t_bar">
      <!-- 白色logo -->
      <div class="t_placeholder">
        <!-- 白色/蓝色图标 -->
        <div class="t_icon t_icon_search02" @click="$emit('openSearch')"></div>
        <div class="t_menu pointer t_menu_blue" @mouseenter="$emit('openMenu')">
          <div class="t_menuitem"></div>
          <div class="t_menuitem t_menuitem2"></div>
          <div class="t_menuitem"></div>
        </div>
      </div>
      <div alt="" class="t_logo t_logo03" />
      <div class="t_right t_blue">
        <div class="mN_lage pointer"></div>
        <div class="mN_lag pointer">
          <div class="text">CN</div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="t_title">
        <div class="t_titleText">专业人员</div>
        <!-- <div class="t_titleBorder"></div>
        <div class="t_titleEng">PROFESSIONAL</div> -->
      </div>
      <div class="m_area">
        <div class="m_logo">
          <img :src="$tools.localStorageFn.get('PAGE_DATE').banner3_logo" alt="" />
        </div>
        <div class="m_search">
          <!-- <input class="m_searchItem" placeholder="按姓氏首字母搜索" /> -->
          <input class="m_searchItem" placeholder="按律师姓名搜索" v-model="name" />
          <el-select v-model="field" placeholder="按业务领域搜索" ref="mySelect_3">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <div class="m_searchBtn" @click="
            $tools.blankPush(
              '/professionalPersonnel?name=' + name + '&field=' + field
            )
            ">
            <div>
              搜索
              <div class="line"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="b_btn" @click="$tools.blankPush('/professionalPersonnel')">
        <div>
          MORE +
          <div class="line"></div>
        </div>
      </div>

      <!-- 底部提示 -->
      <div class="b_left t_blue"></div>
      <div class="b_right_icon t_icon_backTop02" @click="() => {
        $emit('move', 1);
      }
        "></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bg: {
        background:
          "url(" +
          this.$tools.localStorageFn.get("PAGE_DATE").banner3 +
          ") no-repeat center center",
      },
      value: "",
      // 业务领域
      options: [],
      name: "",
      field: "",
      title: '',
    };
  },
  created() {
    this.getTitle(52)
    this.initData();
  },
  methods: {
    // 初始化数据
    initData() {
      this.options = this.$tools.localStorageFn.get("FIELD_LIST");
    },
    getTitle(id) {
      this.$tools.localStorageFn.get("CATEGORIES_LIST").forEach((item) => {
        if (item.id == id) {
          console.log('item', item)
          this.title = item.title;
        } else if (item.children.length > 0) {
          item.children.forEach((ele) => {
            console.log('ele', ele)
            if (ele.id == id) {
              this.title = ele.title;
            }
          })
        }
      })
    },
  },
};
</script>

<style lang="scss">
.homePage04Box {
  height: 100%;
  width: 100%;
  // background: url(~@/assets/images/homeBg04.png) no-repeat center center;
  background-size: 100% 100% !important;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  .content {
    width: 135rem;
  }

  .t_bar {
    z-index: 200;
    position: absolute !important;
    top: 6rem;
    left: 0;
    width: 100%;
    padding: 0 8rem;
    display: flex;
    justify-content: space-between;

    .t_logo {
      width: 20.5rem;
      height: 4.5rem;
    }

    .t_logo02 {
      background: url(~@/assets/images/logo02.png) no-repeat center center;
      background-size: cover;
    }

    .t_logo03 {
      background: url(~@/assets/images/logo03.png) no-repeat center center;
      background-size: cover;
    }

    .t_placeholder {
      height: 4.5rem;
      display: flex;
      align-items: center;

      span {
        cursor: pointer;
      }

      .t_icon {
        cursor: pointer;
        width: 2.8rem;
        height: 2.8rem;
        display: inline-block;
        // margin-left: 3.4rem;
      }

      .t_menu {
        height: 2.6rem;
        margin: 0 3.5rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .t_menuitem {
          width: 2.8rem;
          height: 0.3rem;
          background: #fff;
        }

        .t_menuitem2 {
          // margin: calc((100% - 5.7rem) / 2) auto;
        }
      }

      .t_menu_blue {
        .t_menuitem {
          background: #013060;
        }
      }

      .t_menu:hover .t_menuitem2 {
        transform: translateX(-50%);
      }

      .t_icon_menu {
        background: url(~@/assets/images/icon_menu.png) no-repeat center center;
        background-size: cover;
      }

      .t_icon_menu02 {
        background: url(~@/assets/images/icon_menu02.png) no-repeat center center;
        background-size: cover;
      }

      .t_icon_search01 {
        background: url(~@/assets/images/icon_search01.png) no-repeat center center;
        background-size: 100% 100%;
      }

      .t_icon_search02 {
        background: url(~@/assets/images/icon_search02.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }

    .t_right {
      font-size: 2rem;
      font-family: Microsoft YaHei UI;
      font-weight: 400;
      color: #ffffff;
      line-height: 4.1rem;
      display: flex;
      align-items: center;

      span {
        cursor: pointer;
      }

      .t_icon {
        cursor: pointer;
        width: 2.8rem;
        height: 2.8rem;
        display: inline-block;
        margin-left: 3.5rem;
      }

      .t_menu {
        height: 2.6rem;
        margin-left: 4.3rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .t_menuitem {
          width: 2.8rem;
          height: 0.3rem;
          background: #fff;
        }

        .t_menuitem2 {
          // margin: calc((100% - 5.7rem) / 2) auto;
        }
      }

      .t_menu_blue {
        .t_menuitem {
          background: #013060;
        }
      }

      .t_menu:hover .t_menuitem2 {
        transform: translateX(-50%);
      }

      .t_icon_menu {
        background: url(~@/assets/images/icon_menu.png) no-repeat center center;
        background-size: cover;
      }

      .t_icon_menu02 {
        background: url(~@/assets/images/icon_menu02.png) no-repeat center center;
        background-size: cover;
      }

      .t_icon_search01 {
        background: url(~@/assets/images/icon_search01.png) no-repeat center center;
        background-size: 100% 100%;
      }

      .t_icon_search02 {
        background: url(~@/assets/images/icon_search02.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }

    .t_blue {
      color: #013060 !important;
    }
  }

  .t_title {
    margin-bottom: 13.6rem;

    .t_titleText {
      font-size: 6.4rem;
      font-family: JingZhe_XiaoWei;
      font-weight: 400;
      color: #013060;
      line-height: 4rem;
    }

    .t_titleBorder {
      width: 10rem;
      height: 0.3rem;
      background: #013060;
      margin: 1.2rem auto 1.6rem;
    }

    .t_titleEng {
      font-size: 2.4rem;
      font-family: Microsoft YaHei UI;
      font-weight: 400;
      color: #013060;
      line-height: 2.4rem;
    }
  }

  .m_area {
    display: flex;
    justify-content: space-between;

    .m_logo {

      // width: 118.4rem;
      // height: .3rem;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .m_search {
      margin-left: 3.4rem;

      .m_searchItem {
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        width: 28.5rem;
        height: 5.2rem;
        background: rgba(68, 68, 68, 0);
        border: 0.1rem solid #033061;
        margin-bottom: 0.8rem;
        font-size: 1.6rem;
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        color: #033061;
        line-height: 5.2rem;
        padding: 0 2.4rem;

        .icon_down {
          margin: auto 0;
          width: 2.2rem;
          height: 1.4rem;
          background: url(~@/assets/images/icon_down.png) no-repeat center center;
          background-size: 100% 100%;
        }
      }

      .m_searchItem::placeholder {
        color: #033061;
      }

      .m_searchBtn {
        margin: 0 auto;
        width: 15rem;
        height: 4.2rem;
        background: #013060;
        border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
        font-size: 2rem;
        font-family: SimSun;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        margin-top: 2.2rem;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: 0.5s;

        >div {
          display: inline-block;

          .line {
            width: 0;
            height: 0.1rem;
            background: #fff;
            transition: 0.5s;
          }
        }
      }

      .m_searchBtn:hover {
        background: transparent;
        color: #013060;
        border: 0.1rem solid #013060;

        .line {
          width: 100%;
          background: #013060;
        }
      }

      .el-select .el-input {
        border: 0.1rem solid #033061;
        width: 28.5rem;
        height: 5.2rem;

        input {
          background: rgba(68, 68, 68, 0);
          margin: 0;
          height: 5.2rem;
          line-height: 5.2rem;
          border-radius: 0;
          border: none;
          padding: 0 2.4rem;
          font-size: 1.6rem;
        }

        input::placeholder {
          color: #033061;
          font-size: 1.6rem;
        }

        .el-input__suffix {
          right: 1.8rem;

          .el-input__icon {
            font-size: 2.4rem;
            color: #093665;
            line-height: 5.2rem;
          }
        }
      }
    }
  }

  .b_btn {
    margin: 9.6rem auto;
    width: 24rem;
    height: 5.2rem;
    // background: rgba(31, 31, 46, 0);
    // border: 0.1rem solid #033061;
    font-size: 2.2rem;
    // font-family: Microsoft YaHei UI;
    font-weight: 400;
    color: #01305f;
    text-align: center;
    margin-bottom: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;

    >div {
      display: inline-block;

      .line {
        width: 0;
        height: 0.1rem;
        background: #013060;
        transition: 0.5s;
      }
    }
  }

  .b_btn:hover {

    // background: #013060;
    // color: #fff;
    .line {
      width: 100%;
      // background: #fff;
    }
  }

  @media screen and (min-width: 1920px) {
    .content {
      width: 1400px;
    }

    .t_bar {
      top: 60px;
      padding: 0 80px;

      .t_logo {
        width: 205px;
        height: 45px;
      }

      .t_placeholder {
        height: 45px;

        .t_icon {
          width: 28px;
          height: 28px;
        }

        .t_menu {
          height: 26px;
          margin: 0 35px;

          .t_menuitem {
            width: 28px;
            height: 03px;
          }
        }
      }

      .t_right {
        font-size: 20px;
        line-height: 41px;

        .t_icon {
          width: 28px;
          height: 28px;
          margin-left: 35px;
        }

        .t_menu {
          height: 26px;
          margin-left: 43px;

          .t_menuitem {
            width: 28px;
            height: 03px;
          }
        }
      }
    }

    .t_title {
      margin-bottom: 136px;

      .t_titleText {
        font-size: 64px;
        line-height: 40px;
      }

      .t_titleBorder {
        width: 100px;
        height: 03px;
        margin: 12px auto 16px;
      }

      .t_titleEng {
        font-size: 24px;
        line-height: 24px;
      }
    }

    .m_area {
      .m_search {
        margin-left: 34px;

        .m_searchItem {
          width: 285px;
          height: 52px;
          border: 01px solid #033061;
          margin-bottom: 08px;
          font-size: 16px;
          line-height: 52px;
          padding: 0 24px;

          .icon_down {
            width: 22px;
            height: 14px;
          }
        }

        .m_searchBtn {
          width: 150px;
          height: 42px;
          border-radius: 02px 02px 02px 02px;
          font-size: 20px;
          margin-top: 22px;
        }

        .m_searchBtn:hover {
          border: 1px solid #013060;
        }

        .el-select .el-input {
          border: 01px solid #033061;
          width: 285px;
          height: 52px;

          input {
            height: 52px;
            line-height: 52px;
            padding: 0 24px;
            font-size: 16px;
          }

          input::placeholder {
            font-size: 16px;
          }

          .el-input__suffix {
            right: 18px;

            .el-input__icon {
              font-size: 24px;
              line-height: 52px;
            }
          }
        }
      }
    }

    .b_btn {
      margin: 96px auto 0;
      width: 240px;
      height: 52px;
      font-size: 22px;

      >div {
        .line {
          height: 1px;
        }
      }
    }
  }
}

.active {
  .homePage04Box {
    .t_title {
      animation-name: fade-in-top96;
      animation-duration: 1s;
      animation-timing-function: linear;
      animation-delay: 0s;
      animation-iteration-count: 1;
      animation-direction: normal;
      animation-fill-mode: none;
    }

    .m_logo {
      animation-name: fade-in-left96;
      animation-duration: 1s;
      animation-timing-function: linear;
      animation-delay: 0s;
      animation-iteration-count: 1;
      animation-direction: normal;
      animation-fill-mode: none;
    }

    .m_search {
      animation-name: fade-in-right96;
      animation-duration: 1s;
      animation-timing-function: ease;
      animation-delay: 0s;
      animation-iteration-count: 1;
      animation-direction: linear;
      animation-fill-mode: none;
    }

    .b_btn {
      animation-name: fade-in-bottom96;
      animation-duration: 1.5s;
      animation-timing-function: ease;
      animation-delay: 0s;
      animation-iteration-count: 1;
      animation-direction: linear;
      animation-fill-mode: none;
    }
  }
}
</style>